// extracted by mini-css-extract-plugin
export default {"model":"Modal_model__JSFsS","modelContents":"Modal_modelContents__ZrMIG"};